<template>
  <div style="padding: 10px">
    <!--    搜索区-->
    <div>
      <el-button icon="Plus" type="primary" class="handle-del mr10"
                 @click="createCourseType">新增消课类型
      </el-button>
      <!--      <el-select style="width: 150px" v-model="courseTypeQuery.regionId" placeholder="单选城市" @change="handleSearch"
                       class="handle-select mr10" >
              <el-option
                  v-for="(item,index) in regionList" :key="index"
                  :label="item.regionName"
                  :value="item.regionId"></el-option>
            </el-select>-->
      <el-select style="width: 150px" v-model="courseTypeQuery.regionIdList" placeholder="多选城市"
                 class="handle-select mr10" :multiple="true">
        <el-option
            v-for="(item,index) in regionList" :key="index"
            :label="item.regionName"
            :value="item.regionId"></el-option>
      </el-select>
      <el-input placeholder="请输入课程类型名称" v-model="courseTypeQuery.name" style="width: 150px;"></el-input>
      <el-select v-model="courseTypeQuery.state" placeholder="请选择是否限制状态">
        <el-option label="不限制" value=""></el-option>
        <el-option label="关闭" value="0"></el-option>
        <el-option label="开启" value="1"></el-option>
      </el-select>

      <el-button
          type="primary"
          icon="Search"
          style="margin-left: 10px"
          @click="handleSearch">搜索
      </el-button>
    </div>
    <!--表格区-->
    <el-table
        ref="multipleTable"
        :data="courseTypeList"
        tooltip-effect="dark"
        style="width: 100%;margin-top: 20px;"
        @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          width="55">
      </el-table-column>

      <el-table-column
          prop="id"
          label="id"
          width="60">
      </el-table-column>

      <el-table-column
          prop="courseType"
          label="原签课标识">
      </el-table-column>
      <el-table-column
          prop="courseTypeName"
          label="签课类型名">
      </el-table-column>
      <el-table-column
          prop="courseReduce"
          label="消课数量">
      </el-table-column>
      <el-table-column
          label="应用城市">
        <template #default="scope">
          <span style="display: none">{{ scope.$index }}</span>
          {{ regionList.filter(item => item.regionId === scope.row.useRegionId)[0].regionName + "" }}
        </template>
      </el-table-column>
      <el-table-column
          prop="courseFullRate"
          label="是否计入校比">
        <template #default="scope">
          {{ scope.row.courseFullRate === 1 ? "√" : "X" }}
          <!--          <el-switch
                        v-model="scope.row.courseFullRate"
                        active-color="#13ce66"
                        active-text="是"
                        inactive-text="否"
                        @change="updateCourseType(scope.row)"
                    >
                    </el-switch>-->
        </template>
      </el-table-column>
      <el-table-column
          prop="typeCi"
          label="可否签次卡">
        <template #default="scope">
          {{ scope.row.typeCi === 1 ? "√" : "X" }}
          <!--          <el-switch
                        v-model="scope.row.typeCi"
                        active-color="#13ce66"
                        @change="updateCourseType(scope.row)"
                    >
                    </el-switch>-->
        </template>
      </el-table-column>
      <el-table-column
          prop="typeQi"
          label="可否签期卡">
        <template #default="scope">
          {{ scope.row.typeQi === 1 ? "√" : "X" }}
          <!--          {{scope.row.typeQi}}-->
          <!--          <el-switch
                        v-model="scope.row.typeQi"
                        active-color="#13ce66"
                        @change="updateCourseType(scope.row)"
                    >
                    </el-switch>-->
        </template>
      </el-table-column>
      <el-table-column
          prop="typeHour"
          label="可否签小时卡">
        <template #default="scope">
          {{ scope.row.typeHour === 1 ? "√" : "X" }}

          <!--          {{scope.row.typeHour}}-->
          <!--          -->
        </template>
      </el-table-column>

      <el-table-column width="140" align="center" label="特殊可签课卡型">
        <template v-slot="{ row }">
          <el-tag v-for="(item,index) in row.cardIdList" :key="index">{{ item.cardName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="classFeeType"
          label="课时费类型">
        <template #default="scope">
          {{
            scope.row.classFeeType === 1 ? "1小时课时费" :
                (scope.row.classFeeType === 2 ? "1.5小时课时费" :
                        (scope.row.classFeeType === -1 ? "固定课时费" :
                                (scope.row.classFeeType === 3 ? "2小时课时费" : "常规课时费")
                        )
                )
          }}

          {{ scope.row.classFeeType === -1 ? (" " + scope.row.classFeeMoney + "元") : "" }}
        </template>
      </el-table-column>
      <el-table-column
          prop="state"
          label="状态">
        <template #default="scope">
          {{ scope.row.state === 1 ? "开启" : "关闭" }}
          <!--          {{scope.row.state}}-->
          <!--          -->
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="text" @click="updateCourseType(scope.row)">修改</el-button>
          <!--          <el-button type="text" @click="alert(scope.row)">修改</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!--底部居中按钮-->
    <div style="margin: 0 auto;padding-top:20px;height: 100px;width: 500px;">
      <!--<el-button @click="toggleSelection([courseTypeList[1], courseTypeList[2]])">切换第二、第三行的选中状态</el-button>-->
      <el-button @click="toggleSelection()">取消选择</el-button>
      <el-button @click="dialogCopyCourse = true">复制签课类型</el-button>
    </div>

    <!--    分页-->
    <div style="display: flex;justify-content: end;margin-top: 20px">
      <el-pagination
          v-model:current-page="courseTypeQuery.pageIndex"
          v-model:page-size="courseTypeQuery.pageSize"
          :page-sizes="[20, 50, 100, 150, 200, 250, 300]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="courseTypeTotals"
          @size-change="fetchCourseTypeList"
          @current-change="fetchCourseTypeList"
      />
    </div>

    <!--复制 消课类型 弹框 -->
    <el-dialog
        title="复制 消课类型"
        v-model="dialogCopyCourse"
        width="45%"
        :before-close="handleClose">
      <el-form>

        <el-row>
          <el-form-item label-width="90px" label="目标城市">
            <el-select style="width: 150px" v-model="copyCourseQuery.regionId" placeholder="目标城市"
                       class="handle-select mr10" :disabled="!dialogCopyCourse">
              <el-option
                  v-for="(item,index) in regionList" :key="index"
                  :label="item.regionName"
                  :value="item.regionId"></el-option>
            </el-select>
          </el-form-item>

        </el-row>

      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogCopyCourse = false">取 消</el-button>
          <el-button type="primary" @click="copyCourseFun">确 定</el-button>
        </div>
      </template>
    </el-dialog>

    <!--添加/修改 课程弹框-->
    <el-dialog
        title="新增/修改-消课类型"
        v-model="dialogAddVisible"
        width="45%"
        :before-close="handleClose">
      <el-form>
        <el-row>
          <el-form-item label-width="90px" label="消课类型">
            <el-input placeholder="请输入消课类型名称" v-model="addCourseType.courseTypeName"
                      style="width: 150px;" :disabled="addCourseType.id"></el-input>

          </el-form-item>
          <el-form-item label-width="90px" label="消课数量">
            <el-input placeholder="请输入消课数量" type="number" v-model="addCourseType.courseReduce"
                      style="width: 150px;" :disabled="addCourseType.id"></el-input>

          </el-form-item>

          <el-form-item label-width="90px" label="排序">
            <el-input placeholder="请输入排序" type="number" v-model="addCourseType.typeSort"
                      style="width: 150px;"></el-input>

          </el-form-item>

        </el-row>
        <el-row>
          <el-form-item label-width="90px" label="应用城市">
            <el-select style="width: 150px" v-model="addCourseType.useRegionId" placeholder="应用城市"
                       class="handle-select mr10" :disabled="addCourseType.id">
              <el-option
                  v-for="(item,index) in regionList" :key="index"
                  :label="item.regionName"
                  :value="item.regionId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="90px" label="课时费类型">
            <el-select style="width: 150px" v-model="addCourseType.classFeeType" placeholder="课时费类型"
                       class="handle-select mr10">
              <el-option
                  v-for="(item,index) in classFeeTypeList" :key="index"
                  :label="item.label"
                  :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="固定课时费" label-width="90px" v-if="addCourseType.classFeeType==-1">
            <el-input-number v-model="addCourseType.classFeeMoney"></el-input-number>
          </el-form-item>
          <!--          <el-form-item label-width="90px" label="城市类型">
                      <el-select style="width: 150px" v-model="addCourseType.useFlag" placeholder="城市类型">
                        <el-option label="中招" value="1"></el-option>
                        <el-option label="少年" value="2"></el-option>
                        <el-option label="高考" value="4"></el-option>
                        <el-option label="幼儿" value="5"></el-option>
                      </el-select>
                    </el-form-item>-->
        </el-row>
        <el-row>
          <el-form-item label-width="90px" label="可签次卡">
            <!--            {{addCourseType.typeCi}}-->
            <el-switch
                v-model="addCourseType.typeCi"
                active-color="#13ce66"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label-width="90px" label="可签期卡">
            <!--            {{addCourseType.typeQi}}-->
            <el-switch
                v-model="addCourseType.typeQi"
                active-color="#13ce66"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label-width="90px" label="可签小时卡">
            <!--            {{addCourseType.typeHour}}-->
            <el-switch
                v-model="addCourseType.typeHour"
                active-color="#13ce66"
            >
            </el-switch>
          </el-form-item>

          <el-form-item label-width="90px" label="计入效比">
            <!--            {{addCourseType.courseFullRate}}-->
            <el-switch
                v-model="addCourseType.courseFullRate"
                active-color="#13ce66"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label-width="90px" label="是否开启">
            <!--            {{addCourseType.courseFullRate}}-->
            <el-switch
                v-model="addCourseType.state"
                active-color="#13ce66"
            >
            </el-switch>
          </el-form-item>
        </el-row>
        <!--        可特殊签课卡-->
        <el-row>
          <el-form-item label-width="90px" label="特殊签课卡">
            <el-tag
                v-for="tag in addCourseType.cardIdList"
                :key="tag.cardId"
                closable
                :disable-transitions="false"
                @close="handleTagClose($event,tag)" style="height: 30px;margin: 5px"
            >
              {{ tag.cardName }}
            </el-tag>
            <!--            弹框方式选择卡片-->
            <div class="add-spec" @click="choiceCardRuleDialog=true"> +</div>
            <!--输入卡片ID的操作-->
            <!--<el-popover
                :visible="tempAllowCourseCardRulePopover"
                placement="bottom"
                :width="200">
              <p>请输入卡片课程ID</p>
              <div style="text-align: center">
                <el-input v-model="tempAllowCourseCardRuleId" class="w-50 m-2" placeholder="卡片课程ID"/>
                <div style="text-align: right; margin: 12px">
                  <el-button size="small" type="text" @click="tempAllowCourseCardRulePopover = false">取消</el-button>
                  <el-button type="primary" size="small" @click="addAllowCourseCardRuleId">确定</el-button>
                </div>
              </div>
              <template #reference>
                <div class="add-spec" @click="tempAllowCourseCardRulePopover=true"> +</div>
              </template>
            </el-popover>-->
          </el-form-item>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogAddVisible = false">取 消</el-button>
          <el-button type="primary" @click="addCourseTypeFun">确 定</el-button>
        </div>
      </template>
    </el-dialog>

    <!--    搜索后点选课程卡片弹框-->
    <el-dialog v-model="choiceCardRuleDialog" title="选择课程卡片" width="1200" draggable>
      <div>
        <el-form label-width="70px" class="demo-ruleForm" style="display:flex">
          <el-row>
            <el-col :span="6">
              <el-input v-model="searchCard.name" placeholder="请输入卡片课程名称" style="width:120px"></el-input>
            </el-col>
            <el-col :span="6">
              <el-select style="width: 150px" v-model="searchCard.cityId" placeholder="城市" @change="getRoleList"
                         class="handle-select mr10">
                <el-option
                    v-for="(item,index) in regionAreaList" :key="index"
                    :label="item.name"
                    :value="item.id"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">

              <el-select v-model="searchCard.roleId" filterable placeholder="请选择" @change="searchCardList">
                <el-option v-for="(item,index) in cardRoleList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
            </el-col>
          </el-row>
          <el-button style="display:inline;margin-left: 20px;" @click="searchCardList">查询</el-button>
        </el-form>
        <el-table
            style="margin-top: 10px"
            height="440px"
            :row-style="{height:2+'px'}"
            :cell-style="{color:'#909399',fontSize:'13px',padding:'7px 0px'}"
            :data="courseCardTable" border>
          <el-table-column align="center" show-overflow-tooltip="true" prop="name" label="卡片名称"/>
          <el-table-column align="center" show-overflow-tooltip="true" prop="subtractCourseWayName" label="消课方式"/>
          <el-table-column align="center" show-overflow-tooltip="true" prop="setDateWayName" label="日期设置"/>
          <el-table-column align="center" show-overflow-tooltip="true" prop="howManyDay" label="多少天有效"/>
          <el-table-column align="center" show-overflow-tooltip="true" label="课单价">
            <template #default="scope">{{ scope.row.courseUnitPrice }} 元</template>
          </el-table-column>
          <el-table-column label="课程数量" align="center" show-overflow-tooltip="true">
            <template #default="scope">
              <div>
                {{ scope.row.subtractCourseWay !== 1 ? '期卡' : scope.row.courseNumber + '次' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80px">
            <template #default="scope">
              <el-switch
                  disabled
                  v-model="scope.row.state"
                  active-value="开启"
                  inactive-value="禁用"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80px">
            <template #default="scope">
              <el-button size="small" type="text" @click="confirmAdd($event,'cardRule',scope.$index, scope.row)">添加
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  insertCourseType,
  selectCourseType,
  selectCourseTypeRegion,
  updateCourseType,
  copeCourseTypeDict
  // updateCourseTypeState
} from "@/api/courseType";
import {getRoleListByJsonItem, searchCard} from "@/api/card";
import {selectAreaByExpress} from "@/api/area";

export default {
  name: "CourseTypeManage",
  data() {
    return {
      courseTypeQuery: {
        name: '',
        // regionId: '',
        regionIdList: [],
        regionName: '',
        pageIndex: 1,
        pageSize: 10,
      },//查询课程类型参数
      addCourseType: {
        courseTypeName: '',
        courseReduce: 1,
        courseFullRate: 0,
        typeSort: 0,
        typeCi: 0,
        typeQi: 0,
        typeHour: 0,
        useFlag: 1,
        useRegionId: 1,
        state: 1,
        cardIdList: [],
        classFeeType: 0,
        classFeeMoney: 0,
      },//新增课程类型参数
      classFeeTypeList: [
        {
          label: "固定课时费",
          value: -1
        },
        {
          label: "常规课时费",
          value: 0
        },
        {
          label: "1小时课时费",
          value: 1
        },
        {
          label: "1.5小时课时费",
          value: 2
        },
        {
          label: "2小时课时费",
          value: 3
        }
      ],
      tempAllowCourseCardRuleId: '',//新增可签课卡 临时存储字段
      tempAllowCourseCardRulePopover: false,//添加id的小框是否显示
      regionList: [],//可选城市级别region表格
      regionAreaList: [],//卡片角色前的cityList
      cardRoleList: [],//卡片角色列表list
      courseTypeList: [],//上课类型 表格
      courseTypeTotals: 0,//总条数
      dialogAddVisible: false,//是否显示 添加修改弹框
      choiceCardRuleDialog: false,//查找特殊可签课卡
      searchCard: {
        name: '',
        roleId: null,
        cityId: null,
        pageIndex: 1,
        pageSize: 10
      },//查询卡片
      courseCardTable: [],//搜索到的卡片列表
      dialogCopyCourse: false,//复制签课类型弹框,
      multipleSelection: [],//选中的签课类型
      copyCourseQuery: {//复制消课类型
        regionId: null,
        dictIdList: [],
      },
    }
  },
  created() {
    //默认加载region
    this.selectRegionByAreaId();

    //获取用于卡片角色查找的城市数据
    selectAreaByExpress().then(res => {
      if (res.code === 200) {
        this.regionAreaList = res.data
      } else {
        this.$message.error("获取城市regionAreaList数据失败");
      }
    })
  },
  methods: {
    //切换选中
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    //处理选中
    handleSelectionChange(val) {
      // console.info(11111);
      //原生proxy数组
      this.multipleSelection = val;
      //转换成常规1集合
      const rows = val.map(row => ({...row})); // 将 Proxy 转换为普通对象
      // console.log(rows);
      this.multipleSelection = rows;
    },
    //执行复制
    copyCourseFun() {
      if (this.multipleSelection.length > 0) {
        let dictIdList = this.multipleSelection.map(a => a.id)
        console.info(dictIdList);
        this.copyCourseQuery.dictIdList = dictIdList;
        console.info(this.copyCourseQuery.regionId);
        //执行接口调用
        copeCourseTypeDict(this.copyCourseQuery).then(res => {
          let msgStr = "";
          if (Array.isArray(res.data)) {
            res.data.forEach(i => msgStr += i);
          } else {
            msgStr = res.message;
          }
          if (res.code === 200) {
            this.dialogCopyCourse = false;
            this.$message.success(msgStr);
          } else {
            this.$message.error(msgStr);
          }
        });
      } else {
        this.$message.success("未选中要复制的消课类型!")
      }
    },
    //点击确认添加消课类型,
    addCourseTypeFun() {
      //中转一次-布尔转int
      let tempTypeList = [this.addCourseType];
      //js处理list中的某几项boolean变成int类型
      tempTypeList = tempTypeList.map(item => ({
        ...item,
        courseFullRate: item.courseFullRate ? 1 : 0,
        typeCi: item.typeCi ? 1 : 0,
        typeQi: item.typeQi ? 1 : 0,
        typeHour: item.typeHour ? 1 : 0,
        state: item.state ? 1 : 0
      }));
      //中转完成
      this.addCourseType = tempTypeList[0];

      //是否是修改的
      if (this.addCourseType.id) {
        {
          /*updateCourseTypeState(this.addCourseType).then(res => {
            console.log(res);
            this.$message.info("修改消课类型启用禁用状态成功!" + res.data.message)
          })*/

          updateCourseType(this.addCourseType).then(res => {
            // console.log(res);
            this.$message.success("" + res.data.message)
            this.dialogAddVisible = false;
          })


        }
      } else {
        {
          //是新增的
          insertCourseType(this.addCourseType).then(res => {
            console.log(res);
            this.$message.success("" + res.data.message)
            this.dialogAddVisible = false;
          })
        }
      }
    },
    //获取角色
    async getRoleList() {
      let jsonItem = {'cityId': this.searchCard.cityId}
      await getRoleListByJsonItem(jsonItem).then(res => {
        if (res.code === 200) {
          this.cardRoleList = res.data
        }
      })
    },
    //确认选择可签课卡
    confirmAdd(e, type, index, row) {
      // console.log(e)
      // console.log(type)
      // console.log(index, row);
      //加入到可签课卡list中
      let tempCardRuleList = this.addCourseType.cardIdList ?? [];
      tempCardRuleList.push({
        cardId: row.id,
        cardName: row.name
      });
      this.addCourseType.cardIdList = tempCardRuleList;
      //隐藏查询卡片弹框
      this.choiceCardRuleDialog = false;
    },
    //弹框的关闭
    handleClose(e) {
      console.log(e);
      this.dialogAddVisible = false;
      this.dialogCopyCourse = false;
    },
    //特殊签课卡tag点击x叉号时
    handleTagClose(e, itemParam) {
      let tempCardRuleList = this.addCourseType.cardIdList;
      tempCardRuleList.forEach((item, index) => {
        if (item === itemParam) {
          tempCardRuleList.splice(index, 1)
        }
      })
      this.addCourseType.cardIdList = tempCardRuleList;
    },
    //新增
    createCourseType() {
      // console.log("add")
      this.dialogAddVisible = true;
      // 清空
      this.addCourseType = {
        courseTypeName: '',
        courseReduce: 1,
        courseFullRate: 0,
        typeSort: 0,
        typeCi: 0,
        typeQi: 0,
        typeHour: 0,
        useFlag: 1,
        useRegionId: 1,
        state: 1,
        cardIdList: [],
      };
    },
    handleSearch() {
      this.courseTypeQuery.pageIndex = 1
      this.fetchCourseTypeList();
    },
    //查询
    fetchCourseTypeList() {
      //加载类型
      selectCourseType(this.courseTypeQuery).then(res => {
        // console.log("AAAA222" + JSON.stringify(res))
        if (res.code === 200) {
          this.courseTypeList = res.data.records;
          this.courseTypeTotals = res.data.total;
          //中转一次
          // let tempTypeList = this.courseTypeList;

          //js处理list中的某几项int变成boolean类型
          /*this.courseTypeList = tempTypeList.map(item => ({
            ...item,
            courseFullRate: Boolean(item.courseFullRate),
            typeCi: Boolean(item.typeCi),
            typeQi: Boolean(item.typeQi),
            typeHour: Boolean(item.typeHour),
            state: Boolean(item.state)
          }));*/

          // 直接修改原数组中的 status 属性
          /*tempTypeList.forEach(item => {
            item.courseFullRate = Boolean(item.courseFullRate);
            item.typeCi = Boolean(item.typeCi);
            item.typeQi = Boolean(item.typeQi);
            item.typeHour = Boolean(item.typeHour);
            item.state = Boolean(item.state);
          });
          this.courseTypeList = tempTypeList;
          console.log("typeof tempTypeList[0].state");
          console.log(typeof tempTypeList[0].state);*/
        }
      })

    },

    //加载region
    selectRegionByAreaId() {
      //换region
      selectCourseTypeRegion(this.courseTypeQuery).then(res => {
        // console.log(res);
        if (res.code === 200) {
          this.regionList = res.data
          if (res.data && res.data[0] && res.data[0].regionId) {
            //选中第一个城市
            this.courseTypeQuery.regionIdList.push(res.data[0].regionId)
            //调用加载
            this.fetchCourseTypeList();
          }
        } else {
          this.$message.error("获取城市数据失败");
        }
      })
    },
    //点击修改
    updateCourseType(itemRow) {
      //中转一次
      let tempTypeList = [itemRow];
      //js处理list中的某几项int变成boolean类型
      tempTypeList = tempTypeList.map(item => ({
        ...item,
        courseFullRate: Boolean(item.courseFullRate),
        typeCi: Boolean(item.typeCi),
        typeQi: Boolean(item.typeQi),
        typeHour: Boolean(item.typeHour),
        state: Boolean(item.state)
      }));
      this.addCourseType = tempTypeList[0];
      this.dialogAddVisible = true;
      // console.log(item)

    },
    //查询可签课卡
    searchCardList() {
      // if (this.searchCard.roleId == null) {
      //   this.$message.error('请先选择课程角色！');
      //   return false;
      // }
      searchCard(this.searchCard).then(res => {
        if (res.code === 200) {
          this.courseCardTable = res.data
        } else {
          this.$message.error('查询失败')
        }
      })
    },
    //将输入的课程卡片id加入到addCourseType的cardIdList中
    addAllowCourseCardRuleId(e) {

      console.info("点击了确认")
      console.info(e);

      let tempRuleId = this.tempAllowCourseCardRuleId;
      let tempCardRuleList = this.addCourseType.cardIdList;
      tempCardRuleList.push({
        cardId: tempRuleId,
        cardName: '临时可签课卡' + tempRuleId
      });
      this.addCourseType.cardIdList = tempCardRuleList;
      this.tempAllowCourseCardRulePopover = false

    },
  },
}
</script>

<style scoped>

.add-spec {
  cursor: pointer;
  text-align: center;
  height: 26px;
  line-height: 26px;
  border: dotted 1px #A8ABB2;
  border-radius: 10px;
  color: #A8ABB2;
  padding: 5px 14px;
  margin: 30px 10px 0 10px;
}
</style>
